// src/lib/run-matcher.ts
import { runMatcher, MatchCandidate } from "../logic/trigger-matcher";
import { getNotesForMatcher } from "../state/notes-store";

export async function localMatch(textRaw: string): Promise<MatchCandidate | null> {
  try {
    // Use the same runtime-expanded notes that Live uses
    const notes = getNotesForMatcher();
    // preferNewest mirrors Live's subtle bias behavior
    const best = runMatcher(textRaw, notes, /*activeId*/ null, { preferNewest: true });
    return best;
  } catch {
    return null;
  }
}
